import { put, takeLatest, call } from 'redux-saga/effects'

import { searchUniversities } from '../../core/apiModules/universities'
import { searchDegrees } from '../../core/apiModules/degrees'

import * as educationsModule from '../reducks/educations'
import * as educationsApi from '../apiModules/educations'

function* fetchEducationsSaga(action) {
  try {
    const response = yield educationsApi.fetchEducations(action.payload.id)
    yield put(educationsModule.fetchEducationSuccess(response))
  } catch (error) {}
}

function* createEducationsSaga(action) {
  try {
    const response = yield educationsApi.createEducation(action.payload.id, action.payload.data)
    yield put(educationsModule.createEducationSuccess(response))
    yield put(educationsModule.deleteBlankEducationItem(action.payload.data.tempId))
  } catch (error) {}
}

function* updateEducationSaga(action) {
  try {
    const response = yield educationsApi.updateEducation(action.payload.id, action.payload.data)
    yield put(educationsModule.updateEducationSuccess(response))
    yield call(action.meta.resolve)
  } catch (error) {}
}

function* deleteEducationsSaga(action) {
  try {
    yield educationsApi.deleteEducation(action.payload.id)
    yield put(educationsModule.deleteEducationSuccess(action.payload.id))
  } catch (error) {}
}

function* searchUniversitiesSaga({ meta, payload }) {
  try {
    const response = yield searchUniversities(meta.term)
    yield put(educationsModule.searchUniversitiesSuccess(payload.id, response))
  } catch (error) {
    yield put(educationsModule.searchUniversitiesError(error))
  }
}

function* searchDegreesSaga({ meta, payload }) {
  try {
    const response = yield searchDegrees(meta.term)
    yield put(educationsModule.searchDegreesSuccess(payload.id, response))
  } catch (error) {
    yield put(educationsModule.searchDegreesError(error))
  }
}

export default function* watchEducationsSaga() {
  yield takeLatest(educationsModule.FETCH, fetchEducationsSaga)
  yield takeLatest(educationsModule.UPDATE, updateEducationSaga)
  yield takeLatest(educationsModule.CREATE, createEducationsSaga)
  yield takeLatest(educationsModule.DELETE, deleteEducationsSaga)
  yield takeLatest(educationsModule.SEARCH_UNIVERSITIES, searchUniversitiesSaga)
  yield takeLatest(educationsModule.SEARCH_DEGREES, searchDegreesSaga)
}
